import axios from 'axios';
import { app_actions } from '../actions/app_actions';
import { store } from '../store/index';
import _ from './../utils/lodash';
import * as api_urls from './api_urls';
import { loginSignup_asyncActions } from '../asyncActions/loginSignup_asynActions';
import { app_config } from '../config/app_config';
import { utility } from '../utils';
import Constants from './../config/constants';
import { NavigationConfig } from '../utils/navigation_config';
import i18next from 'i18next';
class Server {
    constructor() {
        this.api_urls = api_urls;
        this.axiosOptions = {
            timeout: 120000,
            transformRequest: [this.transformRequest],
            withCredentials: true
        };
        this.ContentHeaders = {
            Json: 'application/json',
            FormData: 'multipart/form-data',
            Plain: 'text/plain'
        };
        this.BaseDomain = {
            Api: app_config.apiDomain
        };
        this.pendingRequestKeys = new Set();
        this.getDeeplinkSecureToken = () => {
            const url = window.location.pathname;
            const parts = url.split('/');
            const token = parts[parts.length - 1];
            const pathname = parts[parts.length - 2];
            return { token: token, pathname: '/' + pathname };
        };
        this.requestProgress = (updateProgress, addPerCent) => {
            return (progressEvent) => {
                return updateProgress(addPerCent + Math.floor((progressEvent.loaded * 100) / progressEvent.total));
            };
        };
        this.post = (data) => {
            if (data.preventDuplicate) {
                const lockKey = `POST:${data.endPoint}`;
                if (this.pendingRequestKeys.has(lockKey)) {
                    return Promise.reject({ isDuplicateRequest: true, message: 'A request to this endpoint is already in progress.' });
                }
                this.pendingRequestKeys.add(lockKey);
            }
            store.dispatch(app_actions.snackbarMessage(''));
            if (!data.domain) {
                data.domain = api_service.BaseDomain.Api;
            }
            if (!data.headerType) {
                data.headerType = api_service.ContentHeaders.Json;
            }
            if (data.showLoader) {
                store.dispatch(app_actions.showLoader());
            }
            if (data.immediate) {
                store.dispatch(app_actions.showLoaderImmediate());
            }
            if (data.headerType === api_service.ContentHeaders.Json) {
                data.payLoad = JSON.stringify(data.payLoad);
            }
            if (data.cancelRequest) {
                this.cancelRequest(data.cancelRequest);
            }
            let request = axios.post(data.endPoint, data.payLoad, {
                timeout: this.axiosOptions.timeout,
                transformRequest: this.axiosOptions.transformRequest,
                baseURL: data.domain,
                headers: this.getHeadersByType(data.headerType, data.domain, data.customHeaders),
                cancelToken: data.cancelToken
            });
            if (data.preventDuplicate) {
                const lockKey = `POST:${data.endPoint}`;
                request = request.finally(() => { this.pendingRequestKeys.delete(lockKey); });
            }
            if (data.immediate) {
                request = request.finally(() => { store.dispatch(app_actions.hideLoaderImmediate()); });
            }
            return request;
        };
        this.isNetworkError = (error) => {
            return !error.response && error.code !== 'ECONNABORTED';
        };
        this.retry = (config) => {
            return axios(config);
        };
        this.put = (data) => {
            if (data.preventDuplicate) {
                const lockKey = `PUT:${data.endPoint}`;
                if (this.pendingRequestKeys.has(lockKey)) {
                    return Promise.reject({ isDuplicateRequest: true, message: 'A request to this endpoint is already in progress.' });
                }
                this.pendingRequestKeys.add(lockKey);
            }
            store.dispatch(app_actions.snackbarMessage(''));
            let progressConfig = {};
            if (!data.domain) {
                data.domain = api_service.BaseDomain.Api;
            }
            if (!data.headerType) {
                data.headerType = api_service.ContentHeaders.Json;
            }
            if (data.headerType === api_service.ContentHeaders.Json) {
                data.payLoad = JSON.stringify(data.payLoad);
            }
            if (data.showLoader !== false) {
                data.showLoader = true;
            }
            if (data.showLoader) {
                store.dispatch(app_actions.showLoader());
            }
            if (data.immediate) {
                store.dispatch(app_actions.showLoaderImmediate());
            }
            if (data.updateProgress) {
                progressConfig = {
                    onUploadProgress: this.requestProgress(data.updateProgress, 0),
                    onDownloadProgress: this.requestProgress(data.updateProgress, 50)
                };
            }
            let request = axios.put(data.endPoint, data.payLoad, Object.assign({ timeout: this.axiosOptions.timeout, transformRequest: this.axiosOptions.transformRequest, baseURL: data.domain, headers: this.getHeadersByType(data.headerType, data.domain, data.customHeaders) }, progressConfig));
            if (data.preventDuplicate) {
                const lockKey = `PUT:${data.endPoint}`;
                request = request.finally(() => { this.pendingRequestKeys.delete(lockKey); });
            }
            if (data.immediate) {
                request = request.finally(() => { store.dispatch(app_actions.hideLoaderImmediate()); });
            }
            return request;
        };
        this.patch = (data) => {
            store.dispatch(app_actions.snackbarMessage(''));
            if (!data.domain) {
                data.domain = api_service.BaseDomain.Api;
            }
            if (!data.headerType) {
                data.headerType = api_service.ContentHeaders.Json;
            }
            if (data.headerType === api_service.ContentHeaders.Json) {
                data.payLoad = JSON.stringify(data.payLoad);
            }
            if (data.showLoader !== false) {
                data.showLoader = true;
            }
            if (data.showLoader) {
                store.dispatch(app_actions.showLoader());
            }
            return axios.patch(data.endPoint, data.payLoad, {
                timeout: this.axiosOptions.timeout,
                transformRequest: this.axiosOptions.transformRequest,
                baseURL: data.domain,
                headers: this.getHeadersByType(data.headerType, data.domain, data.customHeaders)
            });
        };
        this.delete = (data) => {
            store.dispatch(app_actions.snackbarMessage(''));
            if (!data.domain) {
                data.domain = api_service.BaseDomain.Api;
            }
            if (!data.headerType) {
                data.headerType = api_service.ContentHeaders.Json;
            }
            if (data.showLoader !== false) {
                data.showLoader = true;
            }
            if (data.showLoader) {
                store.dispatch(app_actions.showLoader());
            }
            return axios.delete(data.endPoint, {
                baseURL: data.domain,
                headers: this.getHeadersByType(data.headerType, data.domain, data.customHeaders)
            });
        };
        this.get = (data) => {
            store.dispatch(app_actions.snackbarMessage(''));
            if (!data.domain) {
                data.domain = api_service.BaseDomain.Api;
            }
            if (!data.headerType) {
                data.headerType = api_service.ContentHeaders.Json;
            }
            if (data.showLoader !== false) {
                data.showLoader = true;
            }
            if (data.showLoader) {
                store.dispatch(app_actions.showLoader());
            }
            if (data.cancelRequest) {
                this.cancelRequest(data.cancelRequest);
            }
            return axios.get(data.endPoint, {
                baseURL: data.domain,
                timeout: this.axiosOptions.timeout,
                params: data.payLoad,
                headers: this.getHeadersByType(data.headerType, data.domain, data.customHeaders),
                cancelToken: data.cancelToken,
                responseType: data.responseType
            });
        };
        this.fileUpload = (data) => {
            store.dispatch(app_actions.snackbarMessage(''));
            if (!data.domain) {
                data.domain = this.BaseDomain.Api;
            }
            if (!data.headerType) {
                data.headerType = this.ContentHeaders.FormData;
            }
            if (data.showLoader !== false) {
                data.showLoader = true;
            }
            if (data.showLoader) {
                store.dispatch(app_actions.showLoader());
            }
            const payload = data.payload;
            let payLoadData = data.payload;
            let config = {};
            if (data.id && data.id !== '') {
                let indexToUpdate = -1;
                config = {
                    onUploadProgress: (progressEvent) => {
                        let percentage = (Math.round((progressEvent.loaded * 100) / progressEvent.total));
                        const storeData = store.getState().ui.percentageData;
                        let percentageData = {
                            id: data.id,
                            name: data.fileData.name,
                            type: data.fileData.type,
                            percentage: `${percentage} %`,
                            per_num: percentage
                        };
                        let uploadedData;
                        if (indexToUpdate > -1) {
                            uploadedData = storeData.map((item, i) => i === indexToUpdate
                                ? Object.assign(Object.assign({}, item), { percentage: `${percentage} %`, per_num: percentage }) : item);
                        }
                        else {
                            indexToUpdate = storeData.length;
                            uploadedData = [...storeData, percentageData];
                        }
                        store.dispatch(app_actions.updateUploadPercentage(uploadedData));
                    },
                    headers: this.getHeadersByType(data.headerType, data.domain),
                };
            }
            else {
                config = {
                    headers: this.getHeadersByType(data.headerType, data.domain),
                };
            }
            return axios.post(`${data.domain}${data.endPoint}`, payload, config);
        };
        this.cancelToken = () => {
            const CancelToken = axios.CancelToken;
            return CancelToken.source();
        };
        this.cancelRequest = (source) => {
            source.cancel('');
        };
        axios.interceptors.response.use((response) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
            store.dispatch(app_actions.hideLoader());
            if (response.data) {
                if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 403) {
                    store.dispatch(app_actions.resetStore());
                }
                else if (((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.statusCode) == 426) {
                    store.dispatch(app_actions.setVersionMismatch(true));
                }
                else if (((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.statusCode) > 200 && ((_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.statusCode) !== 401) {
                    if (!((_g = response.config.url) === null || _g === void 0 ? void 0 : _g.includes(api_urls.api_urls.GET_DEEPLINK_CUSTOMER_METADATA)) && !((_h = response.config.url) === null || _h === void 0 ? void 0 : _h.includes(api_urls.api_urls.GET_INSURANCE_QUOTE)) && (((_k = (_j = response === null || response === void 0 ? void 0 : response.data) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.statusCode) !== 204 && ((_m = (_l = response === null || response === void 0 ? void 0 : response.data) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.statusCode) !== 410 && ((_p = (_o = response === null || response === void 0 ? void 0 : response.data) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.statusCode) !== 400)) {
                        utility.alert((_r = (_q = response === null || response === void 0 ? void 0 : response.data) === null || _q === void 0 ? void 0 : _q.data) === null || _r === void 0 ? void 0 : _r.message);
                    }
                }
                else if (((_s = response === null || response === void 0 ? void 0 : response.data) === null || _s === void 0 ? void 0 : _s.statusCode) > 200 && ((_t = response === null || response === void 0 ? void 0 : response.data) === null || _t === void 0 ? void 0 : _t.statusCode) !== 401) {
                    if (!((_u = response.config.url) === null || _u === void 0 ? void 0 : _u.includes(api_urls.api_urls.VERIFY_DEALER_CODE)) && (!((_w = (_v = response === null || response === void 0 ? void 0 : response.config) === null || _v === void 0 ? void 0 : _v.url) === null || _w === void 0 ? void 0 : _w.includes(api_urls.api_urls.GET_DEEPLINK_CUSTOMER_METADATA)) && (!((_y = (_x = response === null || response === void 0 ? void 0 : response.config) === null || _x === void 0 ? void 0 : _x.url) === null || _y === void 0 ? void 0 : _y.includes(api_urls.api_urls.GET_INSURANCE_QUOTE)) && (((_z = response === null || response === void 0 ? void 0 : response.data) === null || _z === void 0 ? void 0 : _z.statusCode) !== 204 && ((_0 = response === null || response === void 0 ? void 0 : response.data) === null || _0 === void 0 ? void 0 : _0.statusCode) !== 410 && ((_1 = response === null || response === void 0 ? void 0 : response.data) === null || _1 === void 0 ? void 0 : _1.statusCode) !== 400)))) {
                        utility.alert((_2 = response === null || response === void 0 ? void 0 : response.data) === null || _2 === void 0 ? void 0 : _2.message);
                    }
                }
            }
            return response;
        }, (error) => {
            var _a, _b, _c, _d;
            const { config } = error;
            if (error.response) {
                if (error.response.status === 403) {
                }
                if (error.response.status !== 401 && error.response.status !== 403) {
                    if (!((_a = config === null || config === void 0 ? void 0 : config.url) === null || _a === void 0 ? void 0 : _a.includes(api_urls.api_urls.GET_INSURANCE_QUOTE))) {
                        utility.alert(error.response.data.message);
                    }
                }
            }
            if (error.message === `timeout of ${this.axiosOptions.timeout}ms exceeded`) {
                error.message = 'Request has been timed out. Please try again.';
                if (!((_b = config === null || config === void 0 ? void 0 : config.url) === null || _b === void 0 ? void 0 : _b.includes(api_urls.api_urls.GET_INSURANCE_QUOTE))) {
                    utility.alert('Request has been timed out. Please try again.');
                }
            }
            if (error.message === 'Network Error') {
                if (navigator.onLine) {
                    error.message = 'We are unable to reach the server. Please try later.';
                    if (!((_c = config === null || config === void 0 ? void 0 : config.url) === null || _c === void 0 ? void 0 : _c.includes(api_urls.api_urls.GET_INSURANCE_QUOTE))) {
                        utility.alert('We are unable to reach the server. Please try later.');
                    }
                }
                else {
                    error.message = 'Please check your internet connection.';
                    if (!((_d = config === null || config === void 0 ? void 0 : config.url) === null || _d === void 0 ? void 0 : _d.includes(api_urls.api_urls.GET_INSURANCE_QUOTE))) {
                        utility.alert('Please check your internet connection.');
                    }
                }
            }
            store.dispatch(app_actions.hideLoader());
            return new Promise((resolve, reject) => {
                if (error.response) {
                    if (error.response.status === 403) {
                        store.dispatch(app_actions.resetStore());
                    }
                    else if (error.response.status === 401) {
                        store.dispatch(app_actions.showLoader());
                        store.dispatch(loginSignup_asyncActions.refreshSession(store.getState().User.session.refreshToken))
                            .then((result) => {
                            store.dispatch(app_actions.hideLoader());
                            const accessToken = result === null || result === void 0 ? void 0 : result.accessToken;
                            if (accessToken) {
                                config.headers.Authorization = `Bearer ${accessToken}`;
                                resolve(this.retry(config));
                            }
                            else {
                                reject(error.response.data);
                            }
                        })
                            .catch(() => {
                            store.dispatch(app_actions.hideLoader());
                            reject(error.response.data);
                        });
                    }
                    else {
                        reject(error.response.data);
                    }
                }
                else {
                    reject(error);
                }
            });
        });
    }
    transformRequest(data) {
        if ((data === null || data === void 0 ? void 0 : data.headerType) === api_service.ContentHeaders.Json) {
            try {
                data = JSON.parse(data);
                let temp = _.clone(data);
                _.map(data, (value, key) => {
                    if (key && key.indexOf('__') > -1) {
                        delete temp[key];
                    }
                });
                return JSON.stringify(temp);
            }
            catch (e) {
                return data;
            }
        }
        else {
            return data;
        }
    }
    getHeadersByType(headerType, domain, customHeaders) {
        var _a, _b;
        let data = {};
        switch (headerType) {
            case api_service.ContentHeaders.Json: {
                data['Content-Type'] = 'application/json';
                break;
            }
            case api_service.ContentHeaders.Plain: {
                data['Content-Type'] = 'text/plain';
                break;
            }
            case api_service.ContentHeaders.FormData: {
                data['Content-Type'] = 'multipart/form-data';
                break;
            }
            default:
                data['Content-Type'] = 'application/json';
                break;
        }
        if (((_a = process.env) === null || _a === void 0 ? void 0 : _a.LOCAL_DEV_ENV) === Constants.ENV.LOCAL_DEV) {
            data['x-domain'] = 'https://dev-vendor2.servicehqtrs.com';
        }
        data['x-dealer-build-version'] = (_b = process.env) === null || _b === void 0 ? void 0 : _b.APP_VERSION;
        data['x-language'] = i18next.language;
        const secureToken = this.getDeeplinkSecureToken();
        if (secureToken.pathname == NavigationConfig.CreateApplicationDeeplink ||
            secureToken.pathname == NavigationConfig.LineOfCreditDeeplink ||
            secureToken.pathname == NavigationConfig.ScheduleTakedownApplicationDeeplink) {
            data['x-securetoken'] = secureToken.token;
        }
        data['Authorization'] = 'Bearer ' + store.getState().User.session.accessToken;
        data = _.extend({}, data, customHeaders);
        return data;
    }
}
export const api_service = new Server();
